import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  MOB_ICONS,
  NoData,
  queryParam,
  SkeltonLoop,
  upperCase,
  useQuery,
  yearBySem,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Skeleton } from "antd";

const DayWiseMarkedAndPending = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [generalData, setGeneralData] = useState([]);

  const [selectedDate, setSelectedDate] = useState([]);

  const params = useParams();
  let searchParams = queryParam(useQuery());

  useEffect(() => {
    console.log(props.college_uuid);
    if (dataList.length < 1) loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    //context.setLoader(true);
    setHoliday([]);
    setDataList([]);
    const form = new FormData();
    form.append("type", "today");
    form.append("with_general", "1");
    form.append("date", props.dayOrder.day_order_date); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("college_uuid", props.college_uuid);
    axios.post(ServiceUrl.MOB.MY_TIME_TABLE, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
        setGeneralData(res["data"].general);
      } else {
        if (res["data"].data) setHoliday(res["data"].data);
      }
      //context.setLoader(false);
      setLoader(false);
    });
  };

  const getIcon = (item, defaultTrue = false) => {
    if (defaultTrue) return MOB_ICONS.CHECKMARK_256;

    return item.attendace_marked_count > 0
      ? MOB_ICONS.CHECKMARK_256
      : MOB_ICONS.TIMEMANAGEMENT_256;
  };

  return (
    <>
      <section className="pt-2 pb-0">
        <div className="row">
          <div className="col-12">
            <div className="bg-white">
              {loader &&
                SkeltonLoop(
                  8,
                  <div className="border-bottom p-2">
                    <Skeleton.Input
                      size="small"
                      loading={true}
                      block={true}
                      active
                    />
                  </div>
                )}
            </div>
            {!loader && dataList.length < 1 && generalData.length < 1 && (
              <NoData className="py-5 mt-5" />
            )}
            <div className="list-group">
              {!loader &&
                dataList.map((item) => (
                  <a className="list-group-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="noti-icons">
                      <img
                        src={getIcon(item)}
                        className="img-fluid"
                        alt=""
                        style={{ width: "30px", height: "30px" }}
                      />
                    </span>
                    <div className="noti-info">
                      <h6 className="mb-0">{item.subject_name}</h6>
                      <span>
                        {item.degreename}-{item.coursename} - (
                        {item.dept_type == "aided" ? "R" : "SF"}) -
                        {yearBySem(item.semester)} - {upperCase(item.section)}
                      </span>
                      {item.room_id && (
                        <div
                          style={{ fontSize: "11px", color: "#1508c9" }}
                          className="mt-2"
                        >
                          <span className="float-start">{item.block_name}</span>
                          <span className="float-end fw-bold">
                            {item.room_name}
                          </span>
                        </div>
                      )}
                    </div>
                    <span className="float-end bg-red-50 text-danger px-1 rounded-circle">{`H${item.hour_value}`}</span>
                  </a>
                ))}
            </div>
          </div>
          {generalData.length > 0 && (
            <>
              <b className="py-2 mt-2">General Entries</b>
              <div className="col-12">
                <div className="list-group">
                  {generalData.map((item, i) => {
                    return (
                      <a className="list-group-item d-flex justify-content-between align-items-center border-0 ">
                        <span className="noti-icons">
                          <img
                            src={getIcon(item)}
                            className="img-fluid"
                            alt=""
                            style={{ width: "30px", height: "30px" }}
                          />
                        </span>
                        <div className="noti-info">
                          <h6 className="mb-0">{item.subject_name}</h6>
                          <span>
                            {item.degreename}-{item.coursename} - (
                            {item.dept_type == "aided" ? "R" : "SF"}) -
                            {yearBySem(item.semester)} -{" "}
                            {upperCase(item.section)}
                          </span>
                        </div>
                        <span className="float-end bg-red-50 text-danger px-1 rounded-circle">{`H${item.hour_value}`}</span>
                      </a>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};
export default DayWiseMarkedAndPending;
